import { Component, OnInit } from '@angular/core';
import {ServicesComponent} from "../services.component";
import {WebDesignComponent} from "./web-design.component";

@Component({
  selector: 'app-marketing',
  template: `
    <div class="service-detail"  id="top">
        <h2><span class="bottomBorder" style="padding-bottom: 4%;">INTERNET</span> MARKETING</h2>
        <div class="scale-less-margin"></div>
        <article>Internet marketing is a set of activities that enable the creation of high-quality and profitable performance of the company or individual on the Internet.
         It consists of the research process, creating strategy and implementation. </article>
        <article style="margin-bottom: 6%">Direct Internet marketing objective is to increase the number of clients, ie.
         increasing your profits. Using marketing constantly remind your customers that you are here.</article>
        <div class="details-container first">
          <div class="checked"></div>
          <h5>Email marketing</h5></div>
        <p style="display: block" class="slider">Email Marketing is used to reach out to current customers by sending out newsletters, coupons or informational emails. You can also encourage new customers to sign up for your newsletter or mailing list to learn more information about the products or services that you provide.</p>
        <div class="details-container second">
          <div class="checkMark"></div>
          <h5>Online display ads</h5></div>
        <p class="slider">Take advantage of online display ads by putting up advertisements on search engines such as Yahoo, Google and Coc Coc. Rich media ads, which are advertisements that allow potential customers to interact with the ad, create more engagement with consumers than your run-of-the-mill text ads. </p>
      </div>
  `,
  styleUrls: ['./marketing.component.css']
})
export class MarketingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.slider();
    WebDesignComponent.firstStart(this, 6);
  }

  slider () {
    $('.first').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.second').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.third').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.forth').click(function () {
      WebDesignComponent.initializeSlide(this);
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/services/descriptionComponents/marketing.component.ts